import React from "react"
import { graphql} from "gatsby"
import { GatsbyImage, getSrc } from "gatsby-plugin-image";
import { FaEnvelope } from "react-icons/fa"
import ReactMarkdown from "react-markdown"
import LayoutGeneric from "../components/LayoutGeneric"
import Seo from "../components/Seo"

const ComponentName = ({data}) => {
  const {content:html, desc, image, title, subtitle, contacts, SEO, aboutGrundium} = data.blog;
  const contactsCount = Boolean(contacts.length);

  return (
    <LayoutGeneric title={title} subtitle={subtitle} image={image.childImageSharp.gatsbyImageData}>
                <Seo
                  title={(SEO && SEO.title) ? SEO.title : title}
                  description={(SEO && SEO.description) ? SEO.description : desc}
                  image={getSrc(image)}
                  article
                />
              <ReactMarkdown source={html} linkTarget="_blank"/>
              {
                contactsCount && (
                  <div className="gs-page-contacts mb4">
                    <header className="gs-sect-header tac">
                    <h2>CONTACTS</h2>
                    </header>
                    <div className="gs-contact-items">
                    {
                    contacts.map((contact)=>{
                    return (
                      <div key={contact.id} className="gs-testim-card">
                          <div className="gs-testim-card-image">
                          <GatsbyImage
                            image={contact.image.childImageSharp.gatsbyImageData}
                            alt=""
                            className="gs-testim-card-pic" />
                          </div>
                          <div className="gs-testim-card-content">
                            <div className="gs-testim-card-author">
                              <h3 className="gs-testim-card-author-name">{contact.name}</h3>
                              <h4 className="gs-testim-card-author-position fw300">{contact.position}</h4>
                              <a href={"mailto:" + contact.email} className="gs-testim-card-link">
                                <FaEnvelope className="gs-footer-link__icon" />
                                <span className="gs-testim-card-link__text">{contact.email}</span>
                              </a>
                            </div>
                          </div>
                        </div>
                    );
                    })
                    }
                    </div>
                  </div>
                  )
              }
              <header className="gs-sect-header tac">
              <h2>{aboutGrundium && aboutGrundium.title ? aboutGrundium.title : "About Grundium"}</h2>
              </header>
              <div>
                {aboutGrundium && aboutGrundium.text ? aboutGrundium.text : "A global leader in advanced imaging technology, Grundium makes digital pathology and best professional diagnosis available for all life – whether human, animal, plant or other. This is achieved by doing something that nobody else can: applying state-of-the-art mobile technology in digital pathology. Established in 2015 by ex-Nokia engineers, the Tampere-based company is democratizing digital pathology with the Ocus® microscope scanners. The cutting-edge imaging solutions are based on over 20 years of experience in optics, sensors and beautiful high-precision devices. Grundium serves various industries and businesses enhancing quality and processes, protecting human life and safeguarding a clean environment."}
              </div>
           </LayoutGeneric>
  );
}

export const query = graphql`
  query GetSingleBlog($slug: String) {
    blog: strapiBlogs(slug: { eq: $slug }) {
      category
      image {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      content
      date
      desc
      slug
      subtitle
      title
      id
      SEO {
        title
        description
      }
      contacts {
        id
        name
        position
        email
        image {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
          }
        }
      }
      aboutGrundium {
        text
        title
      }
    }
  }
`

export default ComponentName
